export const API = "https://sabjigrocery.herokuapp.com/api/v1/";
export const imageLocation = `https://sbg-product-img.s3-us-west-1.amazonaws.com/`